import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {requireImage} from '../../../utils/utils';
import './RightBarSection.scss';

export interface RightBarSectionProps {
    title: string | React.ReactNode;
    isOpen: boolean;
    onToggle: () => void;
    useNewInterface: boolean;
    dir?: string;
    className?: string;
    isHistorySection?: boolean;
    showToggleIcon?: boolean;
    children: React.ReactNode;
}

@observer
export class RightBarSection extends TechseeBaseComponent<RightBarSectionProps> {
    renderInternal(): JSX.Element {
        const {
            title,
            isOpen,
            onToggle,
            useNewInterface,
            dir,
            className = '',
            isHistorySection = false,
            showToggleIcon = true,
            children
        } = this.props;

        const handleHeadingClick = (e: React.MouseEvent<HTMLDivElement>): void => {
            // Allow clicks on interactive children to work, but also toggle on clicks anywhere else
            const target = e.target as HTMLElement;
            // If clicking on an interactive element (like ImageLoader), don't toggle
            if (target.closest('input, button, a, [role="button"]')) {
                return;
            }
            onToggle();
        };

        return (
            <div className={`panel ${className} ${isOpen ? 'open' : ''}`}>
                <div className='panel-heading' onClick={handleHeadingClick}>
                    <div className='side-bar-header-container'>
                        {typeof title === 'string' ? <span>{title}</span> : title}
                        {useNewInterface && showToggleIcon && (
                            <img
                                className={`side-bar-icon ${isOpen ? 'open' : ''} ${dir === 'rtl' ? 'rotate-rtl' : ''}`}
                                src={requireImage('collapsed.png', useNewInterface)}
                                alt='Toggle'
                            />
                        )}
                    </div>
                </div>
                <div className={`panel-body ${isHistorySection ? 'history-panel-body' : ''}`}>{children}</div>
            </div>
        );
    }
}
